/* eslint-disable no-useless-escape */
import React, { useContext, useEffect, FC } from 'react'
import { useHistory } from 'react-router-dom'
import SignupLayout from '../../../layout'
import LeftImageSection from '../../../layout/leftImageSection'
import { SignupContext } from '../../../context/SignupContextContainer'
import SIGNUP_STEPS from '../../../utils/constants'
import ProspectManagementForm from './ProspectManagementForm'

const ProspectManagement: FC = () => {
  const { signupStep } = useContext(SignupContext)
  const history = useHistory()

  useEffect(() => {
    if (signupStep !== SIGNUP_STEPS.PROSPECT) {
      history.push('/client/signup')
    }
  }, [])

  const title = (): JSX.Element => {
    return (
      <div className="left-title">
        <p className="confirm-title">GIVE YOURSELF MORE TIME TO CLOSE THE DEAL.</p>
      </div>
    )
  }
  return (
    <SignupLayout>
      <LeftImageSection title={title()} img="/assets/images/3.jpg" />
      <ProspectManagementForm />
    </SignupLayout>
  )
}
export default ProspectManagement
